import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { bindActionCreators } from 'redux';

import Header from '../../../components/header';
import AddNewAdmin from './addNewAdmin';
import RequestForDeactivation from './requestforDeactivation';
import EditFacility from './editfacility';
// import RequestAdditionalUsers from './requestAdditionalUsers';
import * as SettingActions from './../../../actions/settingScreen_actions';
import Modal from 'react-modal';

// import EditmyProfile from './editmyprofile';

let screenIdentifier = 'settingsScreen';

let AdminSetting = React.createClass({
    getInitialState() {
        return {
            selectedTab: '0',

            // Password verification
            showPasswordModal: false,
            isVerifyPasswordSubmitted: false,
            invalidPasswordErrorMsg: null,
        }
    },
    componentWillReceiveProps(nextProps) {
        // Password Verification Response
        if (this.state.isVerifyPasswordSubmitted) {
            if (nextProps.VerifyPasswordResponse.status == 200) {
                nextProps.VerifyPasswordResponse.status = "";
                this.setState({
                    showPasswordModal: false
                })
            } else {
                this.setState({
                    invalidPasswordErrorMsg: nextProps.VerifyPasswordResponse.message,
                })
            }

            this.setState({
                isVerifyPasswordSubmitted: null,
            });
        }
    },

    componentWillMount() {
        this.setState({
            showPasswordModal: true
        })
    },

    componentDidMount() {

    },
    storeTypeHandler(e) {
        this.setState({ selectedTab: e.target.value });
    },

    navigationHandler() {
    },
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.verifyPassword();
        }
    },

    verifyPassword() {
        if (this.refs.oldPassword.value != "") {
            var PassCheck = {
                "id": this.props.LoginDetails.data.id,
                "uniqueKey": this.props.LoginDetails.data.uniqueKey,
                "password": this.refs.oldPassword.value
            }
            this.setState({
                invalidPasswordErrorMsg: null,
                isVerifyPasswordSubmitted: true,
            });
            this.props.Dispatch(SettingActions.verifyPass(PassCheck));
        }
        else {
            this.setState({
                isVerifyPasswordSubmitted: null,
                invalidPasswordErrorMsg: 'Please enter valid password.',
            });
        }
    },

    removeCancelPrompt() {
        // console.log('entered');

        this.setState({
            showPasswordModal: false,
            invalidPasswordErrorMsg: null,
        });
        // this.props.router.push('/dashboard')

        this.props.router.goBack();
    },

    removeInvalidPasswordErrorMsg() {
        this.setState({
            invalidPasswordErrorMsg: null
        })
    },

    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },

    render() {

        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} />
                <div className="white-box questionnaire">
                    <ul className="nav nav-tabs" role="tablist">
                        <button onClick={this.storeTypeHandler} value='0'
                            className={(this.state.selectedTab === '0' ? 'button active' : 'button')}>ADD NEW ADMIN</button>
                        <button onClick={this.storeTypeHandler} value='1'
                            className={(this.state.selectedTab === '1' ? 'button active' : 'button')}>REQUEST DEACTIVATION</button>
                        <button onClick={this.storeTypeHandler} value='2'
                            className={(this.state.selectedTab === '2' ? 'button active' : 'button')}>EDIT CLINIC</button>
                        {/* <button onClick={this.storeTypeHandler} value='3'
                            className={(this.state.selectedTab === '3' ? 'button active' : 'button')}>REQUEST ADDITIONAL USERS</button> */}

                    </ul>

                    <div className="tab-content settings">
                        {(this.state.selectedTab === '0') && <AddNewAdmin />}
                        {(this.state.selectedTab === '1') && <RequestForDeactivation />}
                        {(this.state.selectedTab === '2') && <EditFacility />}
                        {/* {(this.state.selectedTab === '3') && <RequestAdditionalUsers />} */}
                    </div>
                </div>
                <Modal isOpen={this.state.showPasswordModal} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content profile text-center">
                        <p className='main_header'>
                            Please enter your password to proceed.
                         </p>
                        <div>
                            <div className="input-group">
                                <div className="input-group">
                                    <input type="password" ref="oldPassword" className="inputText" id="password" onChange={this.removeInvalidPasswordErrorMsg} onKeyPress={this.handleKeyPress} required />
                                    <span className="floating-label">PASSWORD</span>
                                    <img src={require('./../../../images/eye-open.png')} className='eye-icon' onClick={() => { this.togglePassword() }} />
                                </div>
                                {this.state.invalidPasswordErrorMsg &&
                                    <div className="error-message">
                                        <span className="red-color">{this.state.invalidPasswordErrorMsg} </span>
                                    </div>}
                            </div>
                            <input type='button' value='SUBMIT' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={this.verifyPassword} onKeyPress={this.handleKeyPress} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        LoginDetails: state.User.loginData,
        VerifyPasswordResponse: state.Setting.verification,
    };
};

let mapDispatchToProps = (dispatch) => ({
    // UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AdminSetting));




/** WEBPACK FOOTER **
 ** ./src/components/admin/clinicSettings/clinicSetting.js
 **/